unit uGlobal;

interface

{$IFDEF DEBUG}
//const F1BET_SERVER = 'http://localhost:1999';
const F1BET_SERVER = 'https://f1bet.trixtercloud.de/api';
{$ELSE}
const F1BET_SERVER = 'https://f1bet.trixtercloud.de/api';
{$ENDIF}

type
  TAppInfo = class
    public
      class var AppProject: string;
      class var AppVersion: string;
      class var AppReleased: string;
      class var AppStarted: TDateTime;

  end;

implementation

end.
